<template>
  <div class="material-box-items">
    <div
      class="material-box"
      @click="downloadMaterial"
    >
      <span>
        <b>{{ courseMaterial.name }}</b>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      courseMaterial: { type: Object, default: () => ({}) }
    },
    methods: {
      downloadMaterial () {
        if (this.courseMaterial.file_url) {
          window.open(this.courseMaterial.file_url)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .material-box-items {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }

  .material-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 5px;
    border: 1px solid $boxBorderPrimaryColor;
    padding: 0.625rem 1.25rem;
    line-height: 1.0625rem;
    font-size: 1rem;
    color: #000;
    transition: .5s all;
    cursor: pointer;

    &:hover {
      background-color: rgba($highlightPrimaryColor, .05);
    }

    &:after,
    &:before {
      content: '';
      display: block;
      background-image: url('~@/assets/img/sprite.png');
    }

    span {
      flex: 1;
    }

    &:before {
      width: 19px;
      height: 25px;
      background-position: -75px -64px;
      margin-right: 10px;
    }

    &:after {
      width: 24px;
      height: 24px;
      background-position: -51px -64px;
      margin-left: auto;
      margin-left: 10px;
    }
  }
</style>